<template>
  <div class="maintenance">
    <call />
    <!-- main -->
    <main>

      <alert :message="alert_msg" :show="alert_show" :closeModal="closeModal" :confirm_show="confirm_show"
        :confirm_message="confirm_msg" :confirm_callback="confirm_callback" :confirm_hide_cancel="confirm_hide_cancel"
        :label_cancel="confirm_label_cancel" :label_ok="confirm_label_ok" confirm_title="只今メンテナンス中です"
        :isShowButton="false">
        <div>
          <div v-if="step >= 10" class="submit-area">
            <input v-model="maintainCode" class="c-input-zip" />
            <button @click="checkMaintainCode" class="c-btn">Ok</button>
          </div>
          <div @click="step++" class="active_area" v-else>
          </div>
        </div>
      </alert>

      <div class="layer" :class="{ fade: !loading }"></div>
      <div class="screen-loader loader--style1" :class="{ fade: !loading }" title="0">
        <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px" y="0px" width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40"
          xml:space="preserve">
          <path opacity="0.2" fill="#000"
            d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z" />
          <path fill="#000"
            d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z">
          </path>
        </svg>
      </div>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import { Tenant } from "../plugin/mixin.js";
import { Common } from "../common/common.js";
import Alert from "../components/Alert.vue";

import Vue from "vue";
import { getMaintain } from "../store/firestore.js";
window._ver = "__VERSION__";

export default Vue.extend({
  name: 'Maintenance',
  components: {
    Alert
  },
  data() {
    return {
      "version": "__VERSION__",
      maintainCode: "",
      step: 0,
      loading: false,
    }
  },
  mixins: [Tenant],
  async mounted() {
    const maintanData = await getMaintain();

    const message = maintanData.message || "いつもイオンタウンアプリをご利用いただきありがとうございます。\n\n現在システムメンテナンス中のためアプリをご利用頂けません。\n\nお客さまにはご不便をおかけいたしますが、何卒ご理解いただきますようお願い申し上げます。 ";
    const result = await this.confirm(message, true);
    if (result) {
      if (Common.isIphone()) {
        Common.messageHandlers("show_browser", { url: "https://apps.apple.com/jp/app/id1538562096" });
      } else if (Common.isAndroid()) {
        Common.messageHandlers("show_browser", { url: "https://play.google.com/store/apps/details?id=jp.co.aeontown.shopping" });
      }
      Common.loadingShow();
    }
    Common.initDom();
  },
  methods: {
    async checkMaintainCode() {
      this.loading = true;
      const result = await getMaintain();
      console.log(1);
      console.log(result);

      if (result.loginCode === this.maintainCode && result.active === true) {
        console.log(2);
        localStorage.setItem("maintainCode", result.loginCode);
        this.$router.push('/');
      }
      this.loading = false;
    },
  },

});
</script>
